import type { FieldState } from '@angular/forms/signals'

/** The part of a Signal Forms field `FieldErrorDirective` reads - any `FieldTree`, whatever its value type. */
export type FieldErrorSource = () => Pick<FieldState<unknown>, 'touched' | 'errors'>

/**
 * What a field shows under it: its first message, once the user has touched it (a submit touches
 * every field). One message, never a list - a second one only repeats that the value is wrong.
 */
export const fieldErrorMessage = (field: FieldErrorSource): string => {
  const state = field()
  return state.touched() ? (state.errors().find((error) => error.message)?.message ?? '') : ''
}
